import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { tabs } from 'src/app/dummy/tabs';
import { DataService } from 'src/app/services/data.service';
import { AddCourseTypeComponent } from './add-course-type/add-course-type.component';
import { List } from 'src/app/stores/administrator/list.store';

@Component({
  selector: 'app-course-type',
  templateUrl: './course-type.component.html',
  styleUrls: ['./course-type.component.scss']
})
export class CourseTypeComponent implements OnInit {
  tabs = tabs.HOLIDAY

  constructor(
    private router: Router,
    public store: List,
    public ds: DataService,
    public dialog: MatDialog) { }

  create(event) {
    const dialogRef = this.dialog.open(AddCourseTypeComponent, {
      data: null,
      panelClass: 'register-test-overlay-panel',
      width: '30vw',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => { });
  }

  ngOnInit() {
    this.store.fetchData(this.ds.courseTypeRef(ref => ref.orderBy("order")))
  }

  ngOnDestroy() {
    this.store.dispost();
  }
}
